import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConversationService } from '../../services/conversation.service';
import { IConversation } from '../../domain/conversation';
import { CommonModule } from '@angular/common';
import { debounceTime } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-chat-history',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './chat-history.html',
  styleUrls: [
    './chat-history.scss',
    '../../../styles/_common.scss'
  ]
})
export class ChatHistory implements OnInit {
  protected coversations = signal<IConversation[]>([]);
  protected searchQueryControl = new FormControl<string | null>(null);
  protected isLoading = signal(false);
  protected IsDeleteDialogShown = signal(false);
  protected selectedCoversationId = signal('');

  private readonly _conversationService = inject(ConversationService);

  constructor() {
    this.load(null);
  }

  public ngOnInit(): void {
    this.searchQueryControl
      .valueChanges
      .pipe(
        debounceTime(300)
      )
      .subscribe(value => this.load(value));
  }

  private load(searchQuery: string | null): void {
    this.isLoading.set(true);
    this._conversationService.getRecent(searchQuery)
      .subscribe({
        next: (data: IConversation[]) => {
          if(!data) {
            return;
          }
          this.coversations.set([...data]);
          this.isLoading.set(false);
        },
        error: (err: any) => {
          console.log('Failed to get conversations', err);
          this.isLoading.set(false);
        },
      });   
  }

  protected delete(conversationId: string): void {
    this.IsDeleteDialogShown.set(true);
    this.selectedCoversationId.set(conversationId);
  }

  protected confirm(): void {
    this.IsDeleteDialogShown.set(false);
    if(!this.selectedCoversationId()) {
      return;
    }
    this._conversationService.delete(this.selectedCoversationId())
      .subscribe({
        next: (data: any) => {
          this.IsDeleteDialogShown.set(false);
          this.selectedCoversationId.set('');
          this.load(this.searchQueryControl.value);
        },
        error: (err: any) => {
          console.log(`Failed to delete conversation with id '${this.selectedCoversationId()}'`, err);
            this.IsDeleteDialogShown.set(false);
            this.selectedCoversationId.set('');
        },
      });   
  }

  protected cancel(): void {
    this.IsDeleteDialogShown.set(false);
    this.selectedCoversationId.set('');
  }
}
